import React from 'react'
import VBEvents from '../components/VBEvents'

const PublicStatsHome = () => {
  return <VBEvents isPublic={true} />
}

export default PublicStatsHome
